import styled from '@emotion/styled';
import React from 'react';
import { ThemeButton } from './ThemeButton';
import { UserDropdown } from './UserDropdown';
import logoUrl from '@/assets/logo.png';

const AppBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--color-border);
  box-sizing: border-box;
  background-color: var(--color-bg-2);
  height: 100%;

  .left {
    display: flex;
    align-items: center;
  }

  .logo {
    display: flex;
    align-items: center;
    width: 200px;
    padding-left: 20px;
    box-sizing: border-box;
  }

  .logo-name {
    color: var(--color-text-1);
    font-weight: 500;
    font-size: 20px;
  }

  .right {
    display: flex;
    list-style: none;
    padding-right: 20px;

    li {
      padding: 0 8px;
      display: flex;
      align-items: center;
    }

    a {
      text-decoration: none;
      color: var(--color-text-1);
    }
  }
`;

function AppBar() {
  return (
    <AppBarWrapper>
      <div className="left">
        <div className="logo">
          <img src={logoUrl} alt="" className="w-10 h-10 rounded-full mr-2" />
          <div className="logo-name">后台管理</div>
        </div>
      </div>
      <ul className="right">
        <li>
          <ThemeButton />
        </li>
        <li>
          <UserDropdown />
        </li>
      </ul>
    </AppBarWrapper>
  );
}

export default AppBar;
